<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <!--        仓库库位-->
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button type="primary" @click="stateUpdateHandler">{{ $t('CargoMsg.Cargo_StateUpdate') }}</el-button>
        <el-button type="primary" @click="importVisible=true">{{ $t('CargoMsg.Cargo_Import') }}</el-button>
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>

      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="250313"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="680px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <div style="display: flex">
          <el-form label-width="80px" label-position="right">
            <el-form-item :label="$t('CargoMsg.Cargo_Warehouse2')" required>
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
                no="airportCargoTerminalUuid"
                filterable
                :method-params="{dataType:1, deletionFlag: false, agencyWarehouse: false}"
                :default-value="editDialog.form.airportCargoTerminalUuid"
                options-width="200px"
                style="width: 200px"
                @parentCallBack="p=>{editDialog.form.airportCargoTerminalUuid=p.value;}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_LocationType')" required>
              <el-select v-model="editDialog.form.locationType" filterable clearable no="locationType">
                <el-option v-for="(item,index) in LOCATION_TYPE_LIST" :key="index" :label="item.chineseName" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-form label-width="100px" label-position="right">
            <el-form-item :label="$t('CargoMsg.Cargo_LocationCode')" required>
              <el-input v-model="editDialog.form.locationCode" no="locationCode" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_LocationStatus')" required>
              <el-select v-model="editDialog.form.locationStatus" filterable clearable no="locationStatus" disabled style="width: 200px">
                <el-option v-for="(item,index) in LOCATION_STATE_LIST" :key="index" :label="item.chineseName" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <el-form label-width="100px" label-position="right">
        <el-form-item :label="$t('CargoMsg.Cargo_RemarksInfo')">
          <el-input v-model="editDialog.form.remarks" type="textarea" :rows="3" no="remarks" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- 库存查看 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="lookDialog.visible"
      :title="lookDialog.title"
      width="680px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <div style="display: flex">
          <el-form label-width="80px" label-position="right" disabled>
            <el-form-item :label="$t('CargoMsg.Cargo_ItemsNBR')">
              <el-input v-model="lookDialog.form.quantity" no="quantity" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_PalletNumber')">
              <el-input v-model="lookDialog.form.palletNo" no="palletNo" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">
              <el-input v-model="lookDialog.form.jobNo" no="jobNo" />
            </el-form-item>
          </el-form>
          <el-form label-width="100px" label-position="right" disabled>
            <el-form-item :label="$t('SeaExport.Weight')">
              <el-input v-model="lookDialog.form.weight" no="weight" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_MblNo')">
              <el-input v-model="lookDialog.form.mblNo" no="mblNo" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_WarehouseNo')">
              <el-input v-model="lookDialog.form.warehouseNo" no="warehouseNo" />
            </el-form-item>
          </el-form>
          <el-form label-width="100px" label-position="right" disabled>
            <el-form-item :label="$t('SeaExport.Cubage')">
              <el-input v-model="lookDialog.form.cubAge" no="cubAge" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_SeparateNumber')">
              <el-input v-model="lookDialog.form.hblNo" no="hblNo" />
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer">
        <div style="text-align: center">
          <el-button no="cancel" @click="lookDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </span>
    </el-dialog>

    <import-dialog
      :title="$t('CargoMsg.Cargo_Import')"
      :action="URL.mdm.importDataUrl"
      :visible="importVisible"
      folder-name="mdm"
      file-name="StorageLocationImport.xls"
      @uploadSuccess="toQuery"
      @onClose="importVisible=false"
    />
  </div>
</template>

<script>
import {
  getLocationConfigurationList,
  saveLocationConfiguration,
  delLocationConfiguration,
  releaseStorageLocationFunc, stateCheckFunc, checkInventoryFunc
} from '@/api/basicData/locationConfiguration'
import { getLoading } from '@/utils/utilBaseElement'
import { DocumentManage } from '@/utils/commonUtil'
import { getUuid } from '@/utils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import { LOCATION_STATE_LIST, LOCATION_TYPE_LIST } from '@/class/cargo/model/parameters/SystemConstants'
import ImportDialog from '@/views/cargo/v0/Information/components/basicData/importDialog.vue'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'WarehouseStorageLocation',
  components: { ImportDialog, AutoNumberInput, cargoAdvanceSelect },
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      URL,
      LOCATION_TYPE_LIST,
      LOCATION_STATE_LIST,
      selectTypeNames: TYPE_NAMES,
      addKey: 'addLocation_',
      total: 0,
      importVisible: false,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AirportCode'),
          field: 'airportCode',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Warehouse2'),
          field: 'warehouseName',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LocationCode'),
          field: 'locationCode',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LocationStatus'),
          field: 'locationStatus',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, LOCATION_STATE_LIST)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LocationType'),
          field: 'locationType',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, LOCATION_TYPE_LIST)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RemarksInfo'),
          field: 'remarks',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: 'locationStatus',
          width: 300,
          minWidth: 200,
          cellRenderer: params => {
            const onReleaseStorageLocation = this.documentManage.getPath('onReleaseStorageLocation')
            const onCheckInventory = this.documentManage.getPath('onCheckInventory')
            return `<button><div onclick="${onCheckInventory}('${params.data.uuid}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_CheckInventory')}</div></button>
                    <button><div onclick="${onReleaseStorageLocation}('${params.data.uuid}')" style="display: inline-block;color:#006EBE;margin-right: 5px;cursor: pointer">${this.$t('CargoMsg.Cargo_ReleaseLocation')}</div></button>`
          }
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          airportCargoTerminalUuid: '',
          locationCode: '',
          locationStatus: 0,
          locationType: 5,
          remarks: ''
        }
      },
      lookDialog: {
        visible: false,
        title: '',
        form: {
          quantity: '',
          palletNo: '',
          jobNo: '',
          weight: '',
          mblNo: '',
          warehouseNo: '',
          cubAge: '',
          hblNo: ''
        }
      },
      documentManage: new DocumentManage()
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onCheckInventory', function(value) {
      context.onCheckInventory(value)
    })
    this.documentManage.set('onReleaseStorageLocation', function(value) {
      context.onReleaseStorageLocation(value)
    })
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    // 查库存
    onCheckInventory(uuid) {
      const self = this
      const rows = self.rowData.filter(p => p.uuid === uuid)
      if (rows && rows.length !== 0) {
        const loading = getLoading()
        checkInventoryFunc({ uuid: rows[0].uuid }).then(res => {
          this.lookDialog.title = self.$t('CargoMsg.Cargo_InventoryCheck')
          this.lookDialog.form = res.data
          this.lookDialog.visible = true
        }).finally(() => loading.close())
      }
    },
    // 释放库位
    onReleaseStorageLocation(uuid) {
      const self = this
      const rows = self.rowData.filter(p => p.uuid === uuid)
      if (rows && rows.length !== 0) {
        releaseStorageLocationFunc({ uuid: rows[0].uuid }).then(res => {
          self.toQuery()
        })
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getLocationConfigurationList(self.filter).then(res => {
        syncSpecificBasicData(basicCacheKeys.basic_data_LocationConfiguration)
        self.rowData = res.data.list
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: this.addKey + getUuid(),
          airportCargoTerminalUuid: '',
          locationCode: '',
          locationStatus: 0,
          locationType: 5,
          remarks: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_WarehouseStorageLocation')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        const form = { ...rows[0] }
        this.editDialog.form = form
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_WarehouseStorageLocation')
      }
      this.editDialog.visible = true
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (form.uuid && form.uuid.indexOf(this.addKey) !== -1) {
        form.uuid = ''
      }
      if (!form.airportCargoTerminalUuid) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PleaseFill') + self.$t('CargoMsg.Cargo_Warehouse2'))
        return
      }
      if (!form.locationCode) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PleaseFill') + self.$t('CargoMsg.Cargo_LocationCode'))
        return
      }
      if (!form.locationType) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PleaseFill') + self.$t('CargoMsg.Cargo_LocationType'))
        return
      }
      const loading = getLoading()
      saveLocationConfiguration(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      }).finally(() => loading.close())
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const row = rows.filter(p => p.locationStatus === 2)
      if (row && row.length > 0) {
        self.$message.warning(self.$t('CargoMsg.Cargo_LocationDeleteTip'))
        return
      }
      self.$confirm(self.$t('CargoMsg.Cargo_DeleteTip1', [rows.length, self.$t('CargoMsg.Cargo_WarehouseStorageLocation')]), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        self.syncRemove(rows, 0)
      }).catch(() => { })
    },
    syncRemove(rows, index) {
      const self = this
      if (index < rows.length) {
        delLocationConfiguration(rows[index].uuid).then(res => {
          self.syncRemove(rows, index + 1)
        }).catch(() => {
          if (index > 0) {
            self.filter.pageNum = 1
            self.toQuery()
          }
        })
      } else {
        self.filter.pageNum = 1
        self.toQuery()
        self.$message.success(self.$t('common.tips.deleteSuccess'))
      }
    },
    stateUpdateHandler() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const uuids = rows.map((row) => {
        return row.uuid
      })
      const loading = getLoading()
      stateCheckFunc(uuids).then(res => {
        self.$message.success(self.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
        self.toQuery()
      }).finally(() => loading.close())
    }
  }
}
</script>

<style>
</style>
